module.exports = __webpack_public_path__ + "355788fea1442327159fee32d1c004fe.png";